module.exports = __webpack_public_path__ + "img/13.ae717668.webp";